import { render, staticRenderFns } from "./search-content.vue?vue&type=template&id=3bc76c2b&"
import script from "./search-content.vue?vue&type=script&lang=ts&"
export * from "./search-content.vue?vue&type=script&lang=ts&"
import style0 from "./search-content.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports